export default __webpack_public_path__ + "static/media/gallery_19.a7edc82d.jpg";